import React from 'react';
import PropTypes from 'prop-types';
import ColumnView from './ColumnView'; // Ensure the path is correct

const ArticlesView = ({
                          columns,
                          handleArticleSelectionChange,
                          handleClaimsSelectionChange,
                          selectedArticles,
                          selectedClaims,
                          formatDate,
                          handleAddUrl,
                          translate,
                          dragable,
                          currentStep,
                          prs,
                          showToastNotification,
                      }) => {
    const articlesViewClass = `articles-view ${columns.length === 1 ? 'single-column' : ''}`;

    return (
        <div className={articlesViewClass}>
            {columns.map((articles, index) => (
                <ColumnView
                    key={`column-${index}`} // Ensure unique key for each ColumnView
                    columnKey={index}
                    articles={articles}
                    handleArticleSelectionChange={handleArticleSelectionChange}
                    handleClaimSelectionChange={handleClaimsSelectionChange}
                    selectedArticles={selectedArticles}
                    selectedClaims={selectedClaims}
                    formatDate={formatDate}
                    handleAddUrl={handleAddUrl}
                    translate={translate}
                    dragable={dragable}
                    hoverable={true}
                    currentStep = {currentStep}
                    prs = {prs}
                    showToastNotification={showToastNotification}
                />
            ))}
        </div>
    );
};

ArticlesView.propTypes = {
    columns: PropTypes.arrayOf(PropTypes.array).isRequired,
    handleArticleSelectionChange: PropTypes.func.isRequired,
    handleClaimsSelectionChange: PropTypes.func.isRequired,
    selectedArticles: PropTypes.array.isRequired,
    selectedClaims: PropTypes.array.isRequired,
    formatDate: PropTypes.func.isRequired,
    handleAddUrl: PropTypes.func.isRequired,
    translate: PropTypes.func,
};

ArticlesView.defaultProps = {
    translate: null,
};

export default ArticlesView;
